import styled from 'styled-components';
import {commonPalette} from '@swipe-guide/clients-shared/styles/palette';
import $Icon from '@swipe-guide/clients-shared/components/Icon';

export const SignInView = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding: 20px 0;
  background-color: white;
`;

export const Caption = styled.h3`
  margin-bottom: 56px;
  font-weight: 600;
  color: ${commonPalette.txBlack};
  font-family: Lato;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
`;

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 428px;
  width: 100%;
  padding: 24px;
`;

export const FormWrapper = styled.form`
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const ErrorNotification = styled.div`
  color: #f31414;
  font-size: 14px;
  font-family: lato;
  padding: 1px 2px 15px 10px;
  margin-left: 10px;
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
`;

export const StyledErrorIcon = styled($Icon).attrs({})`
  width: 16px;
  color: #f31414;
  display: inline-block;
  position: absolute;
`;

export const StyledText = styled.div`
  color: ${commonPalette.textBrand};
  margin: 10px 0;
  text-align: ${({alignText}) => alignText || 'center'};
  font-size: 14px;
`;

export const StyledIcon = styled($Icon).attrs({})`
  width: 16px;
  height: 90%;
  margin-bottom: 3px;
  margin-right: 2px;
`;
export const StyledButtonLink = styled.a`
  color: ${commonPalette.textBrand};
  &:hover {
    color: ${commonPalette.textBrand};
  }
`;
